import { productImageStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.compareCheckbox = {
    ...styles.compareCheckbox,
    css: css`
        ${styles.compareCheckbox?.css}
        align-self: flex-start;
    `,
    mergeCss: true,
};

styles.productImage = {
    ...styles.productImage,
    img: {
        css: css`
            ${styles.productImage?.img?.css}
            width: 100%;
            height: 100px;
            object-fit: contain;
            aspect-ratio: 1 / 1;

            ${mediaQueriesBP.minMD} {
                height: 198px;
            }
        `,
    },
};